import React from 'react'
import { generateComponentpediaLink } from "../../classes/lib-common"

class ComponentpediaLanguages extends React.Component {
    constructor(props){
        super(props)
        this.languages = []
    }

    async get() {
        this.languages = await window.meterian.languages.cpedia() 
    }

    isLanguageSupported(language){
        return this.languages.includes(language)
    }
}


const ComponentpediaLinkSm = (props) => {
    return (
        <a title="See this component in Componentpedia" className={props.className+" cpedia-link"} href={generateComponentpediaLink(props.language, props.name, props.version)} target="_blank" rel="noopener noreferrer"><i className="fas fa-link"></i></a>
    )
}

const ComponentpediaLinkLg = (props) => {
    return (
        <div className={props.className+" cpedia-link report-box"}>
            <div className="report-box-text">
                See this component in <a href={generateComponentpediaLink(props.language, props.name, props.version)} target="_blank" rel="noopener noreferrer">Componentpedia</a>            </div>
        </div>
    )
}

const ComponentpediaLink = (props) => {
    let {language, name, version, type, extraInfo} = props
    if (extraInfo && extraInfo.unityPlugin) return null
    if (!window.componentpediaLanguages.languages.includes(language)) return null
    if ( !type || !Object.keys(ComponentpediaLinkTypes).includes(type)) type=ComponentpediaLinkTypes.SM

    name = name.replace("DLL:", "")
    let className = props.class || ""

    if (type === ComponentpediaLinkTypes.SM) return <ComponentpediaLinkSm className={className} language={language} name={name} version={version}/>
    if (type === ComponentpediaLinkTypes.LG) return <ComponentpediaLinkLg className={className} language={language} name={name} version={version}/>

    return null
}


const ComponentpediaLinkTypes = {
    SM: "SM",
    LG: "LG"
}

export default ComponentpediaLink

export {ComponentpediaLanguages, ComponentpediaLinkTypes}

